import {createAction} from 'typesafe-actions';

import type * as Types from './types';

// User Actions

export const set = createAction(
  '@view/runSet/set',
  action => (ref: Types.Ref, runSetNorm: Types.RunSetPart) =>
    action({ref, runSetNorm})
);

type RunSetUpdate =
  | Partial<Types.RunSetPart>
  | ((prev: Types.RunSetPart) => Types.RunSetPart);

export const update = createAction(
  '@view/runSet/update',
  action => (ref: Types.Ref, runSetUpdate: RunSetUpdate) =>
    action({ref, runSetUpdate})
);

export const visualizeAllIfNoneVisualized = createAction(
  '@view/runSet/selectAllIfNoneSelected',
  action => (ref: Types.Ref) => action({ref})
);

type RunLike = {id: string};

export const setPinnedRun = createAction(
  '@view/runSet/setPinnedRun',
  action => (ref: Types.Ref, run: RunLike, pinned: boolean) =>
    action({ref, run, pinned})
);

export const setBaselineRun = createAction(
  '@view/runSet/setBaselineRun',
  action => (ref: Types.Ref, run: RunLike | null) => action({ref, run})
);
